import setCurrentPage from "src/Utils/setCurrentPage";

const cards: CardDemoProps[] = [
  {
    label: "Data, Analytics & AI",
    title: "Data \nworkbench",
    text: "The Infosys Data Operation Workbench \nPlatform is a unified platform catered for \nend-to-end data operations.",
    choose: {
      label: "CHOOSE",
      onClick: () => setCurrentPage(101),
      endIcon: "arrow-right",
    },
    width: "400px",
  },
  {
    label: "Data, Analytics & AI",
    title: "Zero data \nengineering",
    text: "AI-first data pipeline that processes data \nfrom any source, minimizing the need for \nmanual intervention.",
    choose: {
      label: "CHOOSE",
      onClick: () => setCurrentPage(201),
      endIcon: "arrow-right",
    },
    width: "400px",
  },
  {
    label: "Data, Analytics & AI",
    title: "AI-Twin \nfor marketers",
    text: "Your AI partner that transforms marketing\nwith autonomous recommendations,\nvisibility, decisioning, and activation to\ninspire, engage, and delight consumers in\nreal time.",
    choose: {
      label: "CHOOSE",
      onClick: () => setCurrentPage(301),
      endIcon: "arrow-right",
    },
    width: "400px",
  },
  {
    label: "EdgeVerve",
    title: "AI PLATFORM TO \nEMPOWER DIGITAL CORE \nWITH THE DIGITAL EDGE",
    text: "Shatter digital silos with PolarisEdge that \ndelivers on the promise of Connected \nEnterprise.",
    choose: {
      label: "CHOOSE",
      onClick: () => setCurrentPage(402),
      endIcon: "arrow-right",
    },
    width: "400px",
  },
];

const data = {
  bgVideo: "videos/CORAL_1_1.mp4",
  subtitle: "Select a demo to experience the next ",
  cards: cards,
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
};

export default data;
